import {useSelector} from "react-redux";
import {resolveEffectivePersonalAccountSettings} from 'src/utils/personalAccountSettings'

export const usePermissions = () => {
  const userPermission = useSelector(store => store.user?.permissions)
  const endpointState = useSelector(store => store.endpoint)
  const endpointId = endpointState?.selectedEndpoint?.id
  const personalAccountSettings = resolveEffectivePersonalAccountSettings({
    permissions: userPermission,
    endpointState,
    endpointId,
  })

  return {
    personalAccountSettings,
    isSempCabinet: personalAccountSettings?.is_semp_cabinet === true,
  }
};
